import { render, staticRenderFns } from "./BildirimInfo.vue?vue&type=template&id=d65038a8&scoped=true"
import script from "./BildirimInfo.vue?vue&type=script&lang=ts"
export * from "./BildirimInfo.vue?vue&type=script&lang=ts"
import style0 from "./BildirimInfo.vue?vue&type=style&index=0&id=d65038a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65038a8",
  null
  
)

export default component.exports